import React, { useState, useEffect } from 'react';
import { useOAuth } from '../../context/OAuthContext';
import { oauthAPI } from '../../services/api';
import DebugLogin from './DebugLogin';
import '../admin/AdminComponents.css';

const LoginForm = () => {
  const { login: oauthLogin, loading: oauthLoading, handleOAuthCallback } = useOAuth();
  const [error, setError] = useState('');
  const [debugMode, setDebugMode] = useState(false);
  const [checkingDebug, setCheckingDebug] = useState(true);

  useEffect(() => {
    const checkDebugMode = async () => {
      try {
        const response = await oauthAPI.getDebugUsers();
        if (response.success !== undefined) {
          setDebugMode(true);
        }
      } catch (err) {
        setDebugMode(false);
      } finally {
        setCheckingDebug(false);
      }
    };
    checkDebugMode();
  }, []);

  const handleOAuthLogin = async () => {
    setError('');
    try {
      const success = await oauthLogin('/admin');
      if (!success) {
        setError('Failed to initiate login');
      }
    } catch (err) {
      setError(err.message || 'Failed to initiate login');
    }
  };

  const handleDebugLoginSuccess = () => {
    window.location.reload();
  };

  return (
    <div className="admin-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <h1 className="admin-login-title">Admin Login</h1>
          <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '2rem' }}>
            Sign in with your GTA World account to access the admin panel
          </p>
          {error && (
            <div className="admin-error-message" style={{ marginBottom: '1rem', textAlign: 'center' }}>
              {error}
            </div>
          )}
          <button
            type="button"
            onClick={handleOAuthLogin}
            className="admin-button primary"
            style={{
              width: '100%',
              marginTop: '1rem'
            }}
            disabled={oauthLoading}
          >
            {oauthLoading ? 'Redirecting...' : 'Sign in via GTA World'}
          </button>
          {!checkingDebug && debugMode && (
            <DebugLogin onLoginSuccess={handleDebugLoginSuccess} />
          )}
        </div>
      </div>

    </div>

  );
};

export default LoginForm;

